import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { actionCreators } from "../redux/leadStatusSagas";

export const UpdateBtns = () => {
  const dispatch = useDispatch();
  const filtersDirty = useSelector((state) => state.leadStatus.filtersDirty);

  return filtersDirty ? (
    <>
      <button className="submit" onClick={() => dispatch(actionCreators.updateMetrics())}>
        Update
      </button>
      <button className="submit reset" onClick={() => dispatch(actionCreators.resetFilters())}>
        Reset
      </button>
    </>
  ) : null;
};
